exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flatpickr-input + input {\n  width: 90%;\n}", ""]);

// exports
